import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Over\u00A0Ons', path: '/over-ons' },
    { name: 'Hoe\u00A0werkt\u00A0het?', path: '/hoe-werkt-het' },
    { name: 'Cocktailmenu', path: '/menu' },
    { name: 'Galerij', path: '/galerij' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;
  const isHome = location.pathname === '/';
  // Transparent only on home page while still over the hero
  const transparent = isHome && !scrolled && !isOpen;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const linkBase = 'font-normal text-[15px] transition-colors duration-300 whitespace-nowrap';
  const linkColor = transparent
    ? (active) => (active ? 'text-white font-medium' : 'text-white/90 hover:text-white')
    : (active) => (active ? 'text-cm-primary font-medium' : 'text-gray-700 hover:text-cm-primary');

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent ? 'bg-transparent' : 'bg-white shadow-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <h1
              className={`text-3xl font-bold tracking-wide transition-colors duration-300 ${
                transparent ? 'text-white drop-shadow-lg' : 'text-cm-primary'
              }`}
            >
              Cocktailmannetje
            </h1>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`${linkBase} ${linkColor(isActive(link.path))} ${transparent ? 'drop-shadow-md' : ''}`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/offerte"
              className={`ml-4 px-8 py-3 rounded-lg font-normal transition-all duration-300 shadow-elegant ${
                transparent
                  ? 'bg-white text-cm-primary hover:bg-white/90'
                  : 'bg-cm-primary text-white hover:opacity-90'
              }`}
            >
              Offerte Aanvragen
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`lg:hidden p-2 rounded-md transition-colors ${
              transparent ? 'text-white hover:bg-white/10' : 'text-cm-primary hover:bg-gray-100'
            }`}
            aria-label="Menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-2 font-normal ${
                  isActive(link.path) ? 'text-cm-primary font-medium' : 'text-gray-700'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/offerte"
              onClick={() => setIsOpen(false)}
              className="block btn-primary text-center mt-4"
            >
              Offerte Aanvragen
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
